const defaultUserProfileImage = "https://" + window.location.hostname + "/img/defaultProfilePicture.png";

export const selectCurrentUser = state => state.userState.user;

export const userProfileImage = (user) => {
	return user?.image ?? user?.orgImage ?? defaultUserProfileImage;
}
